import api from '../api'
//import router from '../router'
//import Vue from 'vue'
//import router from '../router'

export default function setup() {
	//Interceptor request
	api.interceptors.request.use(
		function(config) {
			const token = localStorage.getItem('token')
			if (token) {
				config.headers.Authorization = `Bearer ${token}`
			}
			let host = window.location.hostname
      let v = null
			if (host == 'nievedeolla.com') {
				v = 'nvcom-version'
			} else {
				v = 'nv-version'
			}

			let version = localStorage.getItem(v)
			if (version) {
				config.headers.version = version
			}

			return config
		},
		function(err) {
			return Promise.reject(err)
		}
	)

	//Interceptor response
	api.interceptors.response.use(
		function(response) {
			let v = response.headers['nv-version']

			if (v) {
				let version

				let host = window.location.hostname
				if (host == 'nievedeolla.com') {
					version = 'nvcom-version'
				} else {
					version = 'nv-version'
				}

				if (v !== localStorage.getItem(version) && response.config.method == 'get'){
					localStorage.setItem(version, v)
					window.location.reload(true)
				}
			}
			return response
		},
		function(error) {
			if (error.response.status === 401) {
				localStorage.removeItem('token')
			}
			if (error.response.status === 402) {
				let host = window.location.hostname
				let version
				if (host == 'nievedeolla.com') {
					version = 'nvcom-version'
				} else {
					version = 'nv-version'
				}
				localStorage.setItem(version, '0.0.1')
				window.location.reload(true)
			}
		}
	)
}
